import { toast } from 'react-toastify';

export const showErrorMessage = (text: string, isAuthorized: boolean = true) =>
  isAuthorized &&
  toast.error(text, {
    position: 'top-center',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'light',
  });
export const showSuccessMessage = (text: string) =>
  toast.success(text, {
    position: 'top-center',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'light',
  });
